<template>
  <div class="news-slider-wrapper">
    <Loading v-if="loading" class="mt-5 p-5" />
    <b-carousel v-else indicators :fade="true" :interval="5000">
      <template v-if="isFp">
        <b-carousel-slide img-src="./images/slider/finanzpartner01.png" />
      </template>
      <template v-else>
        <!--        <b-carousel-slide img-src="./images/slider/slider1.png" />-->
        <b-carousel-slide img-src="./images/slider/slider2.png" />
        <!--        <b-carousel-slide img-src="./images/slider/slider3.png" />-->
      </template>
      <!--      <b-carousel-slide img-src="./images/slider/slider4.png" />-->
    </b-carousel>
    <Request ref="request" type="trade" :requestInfo="tradeRequest" />
  </div>
</template>

<script>
import { BCarousel } from "bootstrap-vue";
import Loading from "./Loading";
import { getImageFromBytea } from "../store/helpers";
import Request from "./Request";

export default {
  name: "News",
  components: {
    BCarousel,
    Loading,
    Request
  },
  data() {
    return {
      tradeRequest: {
        isSale: false,
        code: "",
        message: "",
        disabled: true
      }
    };
  },
  mounted() {
    // this.$store.dispatch("content/slider");
  },
  methods: {
    // getImage(input) {
    //   return getImageFromBytea(input);
    // },
    showModal(message) {
      this.tradeRequest.message = message;
      this.$refs.request.show();
    }
  },
  computed: {
    // slides() {
    //   return this.$store.state.content.slides;
    // },
    loading() {
      return this.$store.state.content.loading;
    },
    isFp() {
      return window.location.href.indexOf("finanz") !== -1;
    }
  }
};
</script>

<style lang="scss">
.news-slider-wrapper {
  .carousel-item {
    @include media-breakpoint-up(lg) {
      height: 330px;
    }

    @include media-breakpoint-down(lg) {
      height: 400px;
    }

    @include media-breakpoint-down(sm) {
      height: 250px;
    }

    img {
      //max-width: 50% !important;
      //max-height: 85% !important;
      margin-top: -200px;

      @include media-breakpoint-down(lg) {
        margin-top: -260px;
      }

      @include media-breakpoint-down(md) {
        margin-top: -140px;
      }

      @include media-breakpoint-down(sm) {
        margin-top: -50px;
      }
    }

    .carousel-caption {
      position: absolute;
      top: auto;
      bottom: 0;
      right: 0;
      left: auto;
      width: 55%;
      background: $secondary-bg;
      text-align: left;
      padding: 30px;

      @include media-breakpoint-down(lg) {
        position: relative;
        width: 100%;
      }

      h2 {
        font-size: 20px;
        line-height: 150%;
      }

      p {
        font-size: 13px;
        line-height: 115%;
        color: $secondary-text;
      }

      .btn-link {
        color: #fff;
        text-decoration: underline;
        font-size: 13px;
      }
    }
  }

  .carousel-indicators {
    //right: 45%;
    //justify-content: flex-end;
    //align-items: flex-end;
    margin-bottom: 15px;

    //@include media-breakpoint-down(lg) {
    //  position: relative;
    //  justify-content: center;
    //  bottom: -20px;
    //}

    li {
      width: 9px;
      height: 9px;
      margin: 0 0 0 9px;
      padding: 0;
      border-width: 0;
      background: #cbcbcb;
      opacity: 1;
      outline: none;
      box-shadow: none;

      &.active {
        background: $yellow;
      }
    }
  }
}
</style>
